(function () {
  const SELECTORS = {
    thumbSlide: 'xo-carousel-slide.xo-product-info-media-carousel__thumb-slide[data-media-id]',
    // το input που κρατάει το variant id (συνήθως υπάρχει παντού)
    variantIdInput: 'input[name="id"], select[name="id"]',
    // product json: θα το βρούμε από window ή από script tag (βλ. function getProductData)
  };

  function getProductData(root) {
    // 1) Αν το theme σου εκθέτει product json σε script tag (πολύ συχνό)
    const script =
      root.querySelector('script[type="application/json"][data-product-json]') ||
      root.querySelector('script[type="application/json"][id*="ProductJson"]') ||
      root.querySelector('script[type="application/json"][id*="product-json"]');

    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) {}
    }

    // 2) Fallback: Shopify default /product.js δεν είναι ασφαλές χωρίς handle.
    // Αν ΔΕΝ έχεις script json, θα χρειαστώ 1 element ακόμα (το script json ή product handle).
    return null;
  }

  function findVariantIdByMediaId(product, mediaId) {
    if (!product?.variants?.length) return null;

    const mid = String(mediaId);

    // Shopify variants συνήθως έχουν featured_media.id
    const v = product.variants.find(x => String(x.featured_media?.id || '') === mid);
    return v ? String(v.id) : null;
  }

  function setVariant(root, variantId) {
    const input = root.querySelector(SELECTORS.variantIdInput);
    if (!input || !variantId) return;

    if (input.tagName === 'SELECT') {
      if (input.value === variantId) return;
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // input[type=hidden]
    if (input.value === variantId) return;
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getActiveMediaId(root) {
    // XO carousel συνήθως μαρκάρει visibility/active με attribute ή class.
    // Δουλεύουμε με ό,τι βρούμε:
    const active =
      root.querySelector(`${SELECTORS.thumbSlide}[xo-visible]`) ||
      root.querySelector(`${SELECTORS.thumbSlide}.is-active`) ||
      root.querySelector(`${SELECTORS.thumbSlide}[aria-current="true"]`) ||
      root.querySelector(`${SELECTORS.thumbSlide}[tabindex="0"]`);

    return active?.getAttribute('data-media-id') || null;
  }

  function syncVariantFromActiveThumb(root) {
    const product = getProductData(root);
    if (!product) return;

    const mediaId = getActiveMediaId(root);
    if (!mediaId) return;

    const variantId = findVariantIdByMediaId(product, mediaId);
    if (!variantId) return;

    setVariant(root, variantId);
  }

  function bind(root) {
    // Guard για να ΜΗΝ δένεται 2 φορές (αυτό συχνά προκαλεί “κλείδωμα/lag”)
    if (root.dataset.xoMediaVariantBound === 'true') return;
    root.dataset.xoMediaVariantBound = 'true';

    // 1) Click σε thumbnail -> μετά από λίγο sync (για να προλάβει να γίνει active)
    root.addEventListener('click', (e) => {
      const slide = e.target.closest(SELECTORS.thumbSlide);
      if (!slide) return;
      setTimeout(() => syncVariantFromActiveThumb(root), 30);
    }, true);

    // 2) Drag / swipe -> το active αλλάζει με attribute/class -> MutationObserver
    const obs = new MutationObserver(() => {
      // μικρό debounce-like ώστε να μη βαράει συνέχεια
      clearTimeout(root.__xoSyncT);
      root.__xoSyncT = setTimeout(() => syncVariantFromActiveThumb(root), 40);
    });

    obs.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'xo-visible', 'aria-current', 'tabindex']
    });

    // initial
    setTimeout(() => syncVariantFromActiveThumb(root), 50);
  }

  function boot() {
    // δένουμε στο main product area (ή όλο το body αν δεν έχεις wrapper)
    document.querySelectorAll('main, .product, [data-section-type], body').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', boot);

  // Theme editor section reload (πολύ σημαντικό για να μη “διπλοδέσει”)
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
})();
